import type { GameData } from "../gamedata/GameData";
import { GameVer } from "./util/Lang";

export const GD_ALL: Record<GameVer, GameData> = SRV
  ? require("../import/import").importAllData()
  : (null as any);
